/** The file was automatically generated. Please do not modify manually */
import ru from './online.json';
export var strings_ru = ru;
